import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3">
            分类浏览
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            发现你喜欢的
            <span className="font-heading italic text-primary-500">漫画类型</span>
          </h2>
          <p className="mt-2 text-sm text-foreground-500 max-w-lg mx-auto">
            按分类快速找到感兴趣的作品，每个类别都精选优质韩国漫画
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-6 rounded-xl bg-background-100 hover:bg-accent-50 border border-background-200 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors mb-3">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-accent-700 transition-colors whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-400 mt-1 line-clamp-1">{cat.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}